import React from "react"
import PropTypes from "prop-types"
import { StaticImage } from "gatsby-plugin-image"
import { FormattedMessage, changeLocale } from "gatsby-plugin-intl"
import './header.scss'

const Header = () => {
  return <header className='header'>
    <div className='logo'>
      <StaticImage
        src="../images/ft_logo.png"
        width={152}
        quality={95}
        formats={["auto", "webp", "avif"]}
        alt="Fantuan Delivery"
      />
    </div>
    <div className='nation'>
      <span className='lang-icon' />
      <span><FormattedMessage id='index.lang' /></span>
      <div className="change-lang">
        <div className='lang-item' onClick={(e) => { changeLocale('zh') }}>中文</div>
        <div className='lang-item' onClick={(e) => { changeLocale('en') }}>English</div>
        <div className='lang-item' onClick={(e) => { changeLocale('fr') }}>Français</div>
      </div>
    </div>
  </header>
}

Header.propTypes = {
  siteTitle: PropTypes.string,
}

Header.defaultProps = {
  siteTitle: ``,
}

export default Header
